import React from 'react';
import { Menu as MenuPrimitive } from '@headlessui/react';
import { twMerge } from 'tailwind-merge';
import SvgIcon from '../icons/SvgIcon';

type Props = {
  text: string;
  chevron?: boolean;
  className?: string;
};

export default function MenuButton({ text, chevron, className }: Props) {
  return (
    <MenuPrimitive.Button
      className={twMerge(
        'btn px-4 bg-white hover:bg-lightGray text-text',
        className,
      )}
    >
      {text}
      {chevron && (
        <SvgIcon
          name={'HiChevronDown'}
          className="-mr-1 ml-2 h-5 w-5"
          aria-hidden
        />
      )}
    </MenuPrimitive.Button>
  );
}
